// SSEComponent.tsx
import {useEffect} from 'react';
import {useSnapshot} from 'valtio';
import {HistoryStore, sseStore} from '@/utils/store/store';
import {ERROR_MESSAGES} from '@/constants/messages';
import {checkAllParam, handleError} from '@/utils/helpers';
import {addHistory, ApiService} from '@/services/api';
import {fetchEventSource} from '@microsoft/fetch-event-source';
import dayjs from "dayjs";
import {useAuth0} from "@auth0/auth0-react";
import {handleWarnWithErr} from "@/utils/ui-helpers";
import { useSupabaseAuth } from '@/utils/store/supabaseAuth';

type SSEProps = {
  url: string;
};




const SSEComponent = ({ url }: SSEProps) => {
  const { params } = useSnapshot(sseStore);
  const { id, user, isAuthenticated, isLoading } = useSupabaseAuth();

  // const refKey = JSON.stringify(sseStore.params);
  const refKey = JSON.stringify(params);

  console.log("cur params root:", sseStore.params);
  console.log("refKey:", refKey);
  useEffect(() => {
    console.log("cur params:", sseStore.params);
    console.log("cur params2:", JSON.stringify(sseStore.params));
    // 当 content 为空时直接返回
    // let isLegal = checkAllParam(sseStore.params,"Industry","Content","Input_type","Output_type");
    let isLegal = checkAllParam(sseStore.params,"Industry","Content","Output_type");
    console.log("校验结果:", isLegal);

    if (!isLegal) {
      sseStore.loading = false;
      console.error("必填项为空，请补充");
      // handleWarn("必填项为空，请补充");
      // console.log("content", sseStore.params.Content);
      return;
    }

    if (sseStore.loading) {
      console.log("is loading, return");
      // console.log("content", sseStore.params.Content);
      return;
    }
    const controller = new AbortController();

    // 当 params 变化时触发请求
    const fetchData = async () => {
      try {
        sseStore.loading = true;
        sseStore.error = null;

        await fetchEventSource(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // 'Authorization': key
          },
          body: JSON.stringify({
            // app_id: "7451101746413862953",
            parameters:sseStore.params,
            // workflow_id:"7451275515125039123"
          }), // 使用全局存储的参数
          signal: controller.signal,
          onopen: async (response) => {
            if (!response.ok) {
              // debug
              sseStore.trace = sseStore.trace
                + "SSE failed" + JSON.stringify(response) + "\n";
              throw new Error(`SSE failed: ${response.status}`);
            }
          },
          openWhenHidden: true, // 保持后台连接
          onmessage: (event) => {
            try {
              // debug
              sseStore.trace = sseStore.trace + JSON.stringify(event) + "\n";


              // concat data
              if(JSON.parse(event.data)['content']){
                console.log(41,JSON.parse(event.data))
                let content = JSON.parse(event.data)['content'];

                // 删除扣子出现的空字符串对
                content =  content.replace(/\{\}/g, '')
                sseStore.data = sseStore.data + content;
              }
            } catch (err) {
              handleError(err, ERROR_MESSAGES.NETWORK_ERROR);
            throw new Error('SSE data parse error');
            }
          },
          onerror: (err) => {
            // debug
            sseStore.trace = sseStore.trace
              + "SSE Error" + JSON.stringify(err) + "\n";
            handleError(err, ERROR_MESSAGES.NETWORK_ERROR);
            throw err instanceof Error ? err : new Error('SSE error');
          }
        });
      } catch (err) {
        sseStore.error = err instanceof Error ? err : new Error('Unknown error');
      } finally {
        sseStore.trace = sseStore.trace
          + "SSE finish" + "\n";
        sseStore.loading = false;

        // 如果登录了，保存历史
        if(isAuthenticated && !isLoading && id){
          try {
            const response = await addHistory({
              userId: id,
              email: user?.email,
              createTime: dayjs().unix(),
              result: JSON.stringify({ default: sseStore.data }),
              input: JSON.stringify(params)
            });
            console.log(62, response.data);
            if (response.data.success) {
              // 直接使用后端返回的完整item对象添加到HistoryStore.data[0]的第一个位置
              HistoryStore.data[0].unshift(response.data.data);
              
              // 调用genTitle为新创建的历史项生成标题
              HistoryStore.genTitle(id, response.data.data.id);
              
              // 调用addEvaluation接口
              try {
                const evaluationResponse = await ApiService.addEvaluation({
                  result: sseStore.data,
                  Content: params.Content || '',
                  Industry: params.Industry || '',
                  Output_type: params.Output_type || '',
                  historyId: response.data.data.id || ''
                });
                console.log('Evaluation response:', evaluationResponse.data);
              } catch (error) {
                handleWarnWithErr(error, 'Failed to submit evaluation');
              }
            } else {
              handleError(new Error(response.data.data.message), ERROR_MESSAGES.NETWORK_ERROR);
            }
          } catch (error) {
            handleError(error, ERROR_MESSAGES.NETWORK_ERROR);
          }
        }

      }
    };

    fetchData();

    return () => {
      controller.abort();
      sseStore.loading = false;
    };
  }, [url, refKey]); // 监听 params 变化

  return null;
};

export default SSEComponent;